import React, { Component } from 'react';
import LoadingIndicator from 'src/components/LoadingIndicator';
import feathers from 'src/feathers';
import { Button, Col, Container, Row } from 'straightline-ui';

export default class VerifyHighway extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      fetching: true
    };
  }

  componentDidMount() {
    const { code, state: matchId } = this.props.location.query;

    if (!code) {
      this.setState({
        error: {
          message: 'No code was provided.'
        },
        fetching: false
      });

      return;
    }

    feathers
      .service('carrier-api/signup')
      .update(code, {})
      .then(({ user, token }) => {
        return feathers
          .authenticate({
            strategy: 'highway',
            email: user.email,
            password: token
          })
          .then(() => {
            let redirectUrl = '/shipment-matches';
            if (matchId) {
              redirectUrl = `/shipment-matches/${matchId}`;
            }
            this.props.history.push(redirectUrl);
          });
      })
      .catch((error) => {
        this.setState({ error, fetching: false });
      });
  }

  render() {
    const { error, fetching } = this.state;

    if (fetching) {
      return (
        <div className="d-flex vh-100 align-items-center animated fadeIn">
          <LoadingIndicator delay={1500} />
        </div>
      );
    }

    if (error) {
      return (
        <div className="min-h-100vh d-flex align-items-center border-top-2 border-primary">
          <Container>
            <Row className="align-items-center">
              <Col sm="12" md={{ size: 5, offset: 4 }}>
                <h1 className="display-4 text-center mb-3 animated slideInDown">
                  Invalid or Expired Token
                </h1>
                <p className="text-muted text-center mb-5 animated slideInDown">
                  {error.message || ''}
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return (
      <div className="min-h-100vh d-flex align-items-center border-top-2 border-primary">
        <Container>
          <Row className="align-items-center">
            <Col sm="12" md={{ size: 5, offset: 4 }}>
              <h1 className="display-4 text-center mb-3 animated slideInDown">
                Invalid or Expired Token
              </h1>
              <p className="text-muted text-center mb-5 animated slideInDown">
                This link has either already been used or is expired. Account
                Verification links will expire after 7 days.
              </p>
              <Button
                to="/forgot-password"
                color="primary"
                className="animated slideInDown"
                block
              >
                Reset Password
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
